var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountActivities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.75C4 3.67893 5.67893 2 7.75 2H16.25C18.3211 2 20 3.67893 20 5.75V11.2322C19.1025 10.7644 18.0821 10.5 17 10.5C13.4101 10.5 10.5 13.4101 10.5 17C10.5 19.0104 11.4127 20.8077 12.8464 22H7.75C5.67893 22 4 20.3211 4 18.25V5.75ZM7 5.75C7 5.33579 7.33579 5 7.75 5H14.25C14.6642 5 15 5.33579 15 5.75C15 6.16421 14.6642 6.5 14.25 6.5H7.75C7.33579 6.5 7 6.16421 7 5.75ZM7 9.75C7 9.33579 7.33579 9 7.75 9H10.25C10.6642 9 11 9.33579 11 9.75C11 10.1642 10.6642 10.5 10.25 10.5H7.75C7.33579 10.5 7 10.1642 7 9.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12C14.2386 12 12 14.2386 12 17C12 19.7614 14.2386 22 17 22C18.3805 22 19.6315 21.4395 20.5355 20.5355C21.4395 19.6315 22 18.3805 22 17C22 14.2386 19.7614 12 17 12ZM13.5 17C13.5 15.3244 14.6774 13.9239 16.25 13.5805V17C16.25 17.1989 16.329 17.3897 16.4697 17.5303L18.8875 19.9481C18.3428 20.2977 17.6954 20.5 17 20.5C15.067 20.5 13.5 18.933 13.5 17ZM17.75 16.6893V13.5805C19.3226 13.9239 20.5 15.3244 20.5 17C20.5 17.6954 20.2977 18.3428 19.9481 18.8875L17.75 16.6893Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActivities);
export default __webpack_public_path__ + "static/media/account-activities.8e3f406fc5021000b9ddb9834a1f177b.svg";
export { ForwardRef as ReactComponent };